import { FC, ReactNode, useContext, useEffect } from 'react';
import { CommonContainerContext } from './CommonLayoutContainer';
import { PageHeaderProps } from '@ant-design/pro-components';

type TitleProps =
  | {
      children?: never;
      extra: PageHeaderProps['extra'];
      onlyExtra: true;
      onBack?: PageHeaderProps['onBack']
    }
  | {
      children: ReactNode;
      extra?: PageHeaderProps['extra'];
      onlyExtra?: never;
      onBack?: PageHeaderProps['onBack']
    };

export const CommonContainerTitle: FC<TitleProps> = ({ children, extra, onBack, onlyExtra = false }) => {
  const { setTitle, setExtra, setBackAction } = useContext(CommonContainerContext);

  useEffect(() => {
    if (!onlyExtra) {
      setTitle(children);
    }

    setExtra(extra);

    setBackAction(onBack);
  }, [children, extra, onlyExtra, onBack]);

  useEffect(() => {
    return () => {
      if (!onlyExtra) {
        setTitle(null);
      }

      setExtra(null);

      setBackAction(undefined);
    };
  }, []);

  return null;
};
